import { useState, memo } from "react";
import styled, { css } from "styled-components";

const StyledDropdown = styled.div`
  transition: opacity 0.125s cubic-bezier(0, 0.89, 0.58, 1),
    box-shadow 0.75s ease-out, transform 0.25s ease-out;
  border-radius: 4px;
  background: ${({ theme }) => theme?.color?.whiteBase};
  box-shadow: 0 0px 10px ${({ theme }) => `${theme?.color?.grayBase}12`},
    0 2.8px 2.2px rgba(0, 0, 0, 0.034), 0 6.7px 5.3px rgba(0, 0, 0, 0.048),
    0 12.5px 10px rgba(0, 0, 0, 0.06), 0 22.3px 17.9px rgba(0, 0, 0, 0.072),
    0 41.8px 33.4px rgba(0, 0, 0, 0.086), 0 100px 80px rgba(0, 0, 0, 0.12);

  padding: 10px;
  position: absolute;
  right: 20px;
  width: 155px;

  ${({ $show }) =>
    !$show &&
    css`
      display: hidden;
      opacity: 0%;
      pointer-events: none;
      box-shadow: none;
      transition-duration: 0.125s;
      transform: translateY(-5px);
    `}
`;

const StyledSwitchLanguage = styled.div`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  align-items: center;
  display: flex;
  justify-content: center;
  .popup {
    max-width: 1200px;
  }
`;

const StyledSwitchLanguageButton = styled.div`
  cursor: pointer;
  display: flex;
  div {
    font-size: 14px;
    font-weight: normal;
    margin-right: 10px;
    text-transform: uppercase;
  }
`;

const StyledDropdownItem = styled.div`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  cursor: pointer;
  padding: 5px;
  &:hover {
    background-color: ${({ theme }) => theme?.color?.grayWhisper};
  }

  ${({ $disabled }) =>
    $disabled &&
    css`
      color: ${({ theme }) => theme?.color?.grayD3};
      cursor: default;
      &:hover {
        background-color: ${({ theme }) => theme?.color?.whiteBase};
      }
    `}
`;

const StyledDropdownContainer = styled.div`
  position: absolute;
  width: 100%;
  margin-top: 3em;
  margin-left: -7px;
`;

const Switch = memo(({ langCode }) => {
  return (
    <StyledSwitchLanguageButton>
      <div>{langCode}</div>
      <img src="/images/expand_more.svg" alt="show more" />
    </StyledSwitchLanguageButton>
  );
});

const LanguageSwitch = memo(({ handleSwitchLanguage, langCode }) => {
  const [shouldShowLanguages, setShouldShowLanguages] = useState(false);
  const handleToggle = () => {
    setShouldShowLanguages(!shouldShowLanguages);
  };

  const handleSelectLanguage = (lang) => {
    if (lang !== langCode) {
      setShouldShowLanguages(false);
      handleSwitchLanguage(lang);
    }
  };
  return (
    <>
      <StyledSwitchLanguage onClick={() => handleToggle()}>
        <Switch langCode={langCode} />
      </StyledSwitchLanguage>
      <StyledDropdownContainer>
        <StyledDropdown $show={shouldShowLanguages}>
          <StyledDropdownItem
            $disabled={langCode === "th"}
            onClick={() => handleSelectLanguage("th")}
          >
            ไทย
          </StyledDropdownItem>
          <StyledDropdownItem
            $disabled={langCode === "en"}
            onClick={() => handleSelectLanguage("en")}
          >
            English
          </StyledDropdownItem>
        </StyledDropdown>
      </StyledDropdownContainer>
    </>
  );
});

export default LanguageSwitch;
